import { DataSample } from '../../model/dto/data-sample.type';
import { DateTime, Interval } from 'luxon';

export type ValueFn = (timestamp: DateTime) => number;

export const simpleSinusFn: ValueFn = (timestamp) => Math.abs(10 * Math.sin(10 * timestamp.toMillis()));

export function generateSamples(start: DateTime, end: DateTime, offset: number, valueFn: ValueFn = simpleSinusFn): DataSample[] {
    return Interval.fromDateTimes(start, end).splitBy({ minute: 15 })
        .map((interval) => interval.start!)
        .map((timestamp) => ({ timestamp, value: valueFn(timestamp) + offset }));
}
